import { t } from '../../utils/i18n';
import { updateLeadPortal } from '../../services/digitsCodeService';
import { appointmentItemsClickEventHandler } from '../actions/selectTimeActions';
import { leadInfo, selectedAppointmentUnixTime } from '../../utils/variables';

export function addressCollectionListeners() {
    const container = document.querySelector('.address-collection__container');
    if (!container) return;

    const line1 = container.querySelector('#addressLine1');
    const city = container.querySelector('#addressCity');
    const state = container.querySelector('#addressState');
    const zip = container.querySelector('#addressZip');
    const btn = container.querySelector('.address-collection__btn');

    function validate() {
        const valid = line1.value.trim() && city.value.trim() && state.value.trim() && zip.value.trim();
        btn.classList.toggle('disabled', !valid);
    }

    [line1, city, state, zip, container.querySelector('#addressLine2')].forEach((el) => {
        if (el) el.addEventListener('input', validate);
    });

    btn.addEventListener('click', async () => {
        if (btn.classList.contains('disabled')) return;
        btn.classList.add('disabled');
        btn.textContent = t('saving');

        const addressData = {
            address1: line1.value.trim(),
            address2: (container.querySelector('#addressLine2')?.value || '').trim(),
            city: city.value.trim(),
            state: state.value.trim(),
            zip: zip.value.trim(),
        };

        try {
            await updateLeadPortal(leadInfo.text_id, addressData);

            // Create + book the appointment only now that address is captured, so the
            // booking cannot be completed without it. appointmentItemsClickEventHandler
            // handles the create → deposit/confirm flow (see selectTimeActions.js).
            await appointmentItemsClickEventHandler(selectedAppointmentUnixTime, addressData);
        } catch (e) {
            btn.classList.remove('disabled');
            btn.textContent = t('continue');
        }
    });
}
